import axios from "axios";
import { server } from "../../server";

// Get all events for a shop
export const getAllEventsShop = (shopId) => async (dispatch) => {
  try {
    dispatch({ type: "getAllEventsShopRequest" });
    const { data } = await axios.get(`${server}/event/get-all-events/${shopId}`);
    dispatch({ type: "getAllEventsShopSuccess", payload: data.events });
  } catch (error) {
    dispatch({
      type: "getAllEventsShopFailed",
      payload: error.response?.data?.message,
    });
  }
};

// Get all events (public)
export const getAllEvents = () => async (dispatch) => {
  try {
    dispatch({ type: "getAllEventsRequest" });
    const { data } = await axios.get(`${server}/event/get-all-events`);
    dispatch({ type: "getAllEventsSuccess", payload: data.events });
  } catch (error) {
    dispatch({
      type: "getAllEventsFailed",
      payload: error.response?.data?.message,
    });
  }
};

// Delete an event
export const deleteEvent = (id) => async (dispatch) => {
  try {
    dispatch({ type: "deleteEventRequest" });
    const { data } = await axios.delete(`${server}/event/delete-shop-event/${id}`, {
      withCredentials: true,
    });
    dispatch({ type: "deleteEventSuccess", payload: data.message });
  } catch (error) {
    dispatch({
      type: "deleteEventFailed",
      payload: error.response?.data?.message,
    });
  }
};

// Create event
export const createevent = (formData) => async (dispatch) => {
  try {
    dispatch({ type: "createEventRequest" });
    const { data } = await axios.post(`${server}/event/create-event`, formData, {
      withCredentials: true,
    });
    dispatch({ type: "createEventSuccess", payload: data.event });
  } catch (error) {
    dispatch({
      type: "createEventFailed",
      payload: error.response?.data?.message,
    });
  }
};
